module.exports = __webpack_public_path__ + "media/DeluxNargila.5533b6bf.mp4";